import { render } from "./objectives.vue?vue&type=template&id=43963c7e"
import script from "./objectives.vue?vue&type=script&lang=js"
export * from "./objectives.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__